import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCursorClick20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCursorClick20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.7 8.048a4.12 4.12 0 1 0-4.667 4.65l.385 1.537a5.62 5.62 0 1 1 5.819-5.777zm-3.864 2.306a1.75 1.75 0 1 1 1.519-1.518l6.194 1.77a.75.75 0 0 1 .09 1.41l-2.493 1.069 2.728 2.728a.75.75 0 1 1-1.06 1.06l-2.73-2.728-1.068 2.494a.75.75 0 0 1-1.41-.09zm3.715 1.782 1.558-.667-3.697-1.056 1.057 3.696.668-1.56.011-.025.113-.263.26-.112z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCursorClick20);
